import { AfterViewInit, Component, Injector, OnInit, ViewChild } from '@angular/core';
import { UserGroupType } from 'tnx-admin-service/authorization/constants';
import { PermissionService } from 'tnx-admin-service/authorization/permission/services';
import { UserGroupService } from 'tnx-admin-service/authorization/usergroup/services';
import { ComCtxConstants, ComponentContextService, CrudListComponent, DataListBase } from 'tnx-shared';

@Component({
    selector: 'app-userpermission',
    templateUrl: './userpermission.component.html',
    styleUrls: ['./userpermission.component.scss'],
    providers: [ComponentContextService]
})
export class UserPermissionComponent extends DataListBase implements OnInit, AfterViewInit {
    @ViewChild('crudList', { static: false }) crudList: CrudListComponent;
    searchSchema: any = {};
    searchData: any = {};
    submitting: any;
    countLoading: any;

    constructor(
        protected _injector: Injector,
        protected _userGroupService: UserGroupService,
        private _permissionServiec: PermissionService
    ) {
        super(_injector);
    }

    ngOnInit() {
        this._commonService.toggleMenu();
        this.setting.baseService = this._userGroupService;
        this.setting.objectName = 'nhóm người dùng';
        this.setting.popupSize.height = 700;
        this.setting.popupSize.width = 1000;
        super.ngOnInit();
    }

    async savePermission() {
        let requestModel: any = {
            subjectType: this.model.advanceData.filter.type,
            addRoleIds: this.model.advanceData.role.addRoleIds,
            removeRoleIds: this.model.advanceData.role.removeRoleIds,
            addPermissionIds: this.model.advanceData.permission.addPermissionIds,
            removePermissionIds: this.model.advanceData.permission.removePermissionIds,
        };

        if (this.model.advanceData.filter.type == UserGroupType.User
            || this.model.advanceData.filter.type == UserGroupType.Client) {
            requestModel = {
                ...requestModel,
                idUsers: this.model.advanceData.filter.ids
            };
        }
        else {
            requestModel = {
                ...requestModel,
                idUserGroups: this.model.advanceData.filter.ids
            };
        }

        this.showWaitBox();
        const response = await this._permissionServiec.PhanQuyenNguoiDung(requestModel);
        this.hideWaitBox();

        if (response.success) {
            this._notifierService.showUpdateDataSuccess();
            this.context.fireEvent(ComCtxConstants.PERMISSION.REFRESH_PERMISSION);
        }
        else {
            this._notifierService.showUpdateDataFailed();
        }
    }

    refresh() {
        // this._router.navigateByUrl('/authorization/userpermission', { skipLocationChange: true }).then(() =>
        //     this._router.navigate(['/authorization/userpermission'])
        // );

        this.context.fireEvent(ComCtxConstants.PERMISSION.REFRESH_USER_PERMISSION);
    }
}
